import Model from "../Model";

class Representantbubblesdetailuser extends Model{

    buildUrl ({ param }) {
        return ['employeeview/detailsbyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Representantbubblesdetailuser;